import { render, staticRenderFns } from "./InsightsTextSummary.vue?vue&type=template&id=63baba48"
import script from "./InsightsTextSummary.vue?vue&type=script&lang=js"
export * from "./InsightsTextSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports